import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#2e186a"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 13px 0;
  min-height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid rgb(255, 130, 92);
    background-color: rgb(255, 130, 92);
  }

  &:active {
    transform: translateY(1px) scale(0.99);
  }

  &:disabled,
  &[aria-busy="true"] {
    color: #fff;
    border-color: #1f9d74;
    background-color: #1f9d74;
    cursor: progress;
    opacity: 0.94;
  }

  &:disabled:hover,
  &[aria-busy="true"]:hover {
    border-color: #1f9d74;
    background-color: #1f9d74;
  }

  &:disabled::after,
  &[aria-busy="true"]::after {
    content: "";
    width: 0.75rem;
    height: 0.75rem;
    border: 2px solid rgb(255 255 255 / 50%);
    border-top-color: #fff;
    border-radius: 50%;
    animation: button-spin 0.8s linear infinite;
  }

  @keyframes button-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
